import React, { useState } from 'react'
import { SearchableSelectBase } from 'components'
import { useCountriesOptions } from '../../hooks'

type Props = {
  initialOption: SelectOption
  disabled?: boolean
  onSelect: (selectOption: SelectOption) => void
}

const CountriesSelect = (props: Props) => {
  const [searchText, setSearchText] = useState<string>('')
  const { data, isLoading } = useCountriesOptions(searchText)

  return (
    <SearchableSelectBase
      {...props}
      options={data}
      onSearch={(newSearchText: string) => setSearchText(newSearchText)}
      isLoading={isLoading}
    />
  )
}

export default CountriesSelect
